import React from "react";

export default function DashboardNav({
  active,
  onChange,
  transportEwbEnabled,
  onTransportEwbChange,
  revenueType,
  onRevenueTypeChange,
}) {
  const menus = [
    { key: "companies", label: "Company Details" },
    { key: "clients", label: "Transport Clients" },
    { key: "servers", label: "Server Details" },
    { key: "ewb_errors", label: "EWB Errors" },
    { key: "revenues", label: "Revenues" },
  ];

  return (
    <div className="dashboard-nav dashboard-nav-wrap">
      {/* LEFT MENU */}
      <div className="dashboard-nav-left">
        {menus.map((menu) => (
          <button
            key={menu.key}
            className={
              active === menu.key
                ? "dashboard-nav-btn active"
                : "dashboard-nav-btn"
            }
            onClick={() => onChange(menu.key)}
          >
            {menu.label}
          </button>
        ))}
      </div>

      {/* RIGHT RADIO BUTTONS */}
      {active === "clients" && (
        <div className="dashboard-nav-right">
          <span className="toggle-label">Transport EWB Issues</span>

          <div className="radio-toggle">
            <label>
              <input
                type="radio"
                name="ewb"
                checked={!transportEwbEnabled}
                onChange={() => onTransportEwbChange(false)}
              />
              <span>Hide</span>
            </label>

            <label>
              <input
                type="radio"
                name="ewb"
                checked={transportEwbEnabled}
                onChange={() => onTransportEwbChange(true)}
              />
              <span>Show</span>
            </label>
          </div>
        </div>
      )}

      {active === "revenues" && (
        <div className="dashboard-nav-right">
          <span className="toggle-label">Revenue Type</span>

          <div className="radio-toggle">
            <label>
              <input
                type="radio"
                name="revenue"
                checked={revenueType === "transport"}
                onChange={() => onRevenueTypeChange("transport")}
              />
              <span>Transport</span>
            </label>

            <label>
              <input
                type="radio"
                name="revenue"
                checked={revenueType === "saral"}
                onChange={() => onRevenueTypeChange("saral")}
              />
              <span>Saral eWay</span>
            </label>
          </div>
        </div>
      )}
    </div>
  );
}
